import React from "react";

import Shimmer from "../../Shimmer";
import LandingTypography from "../../landingPage/components/LandingTypography";

import "./StockBasicDataSummaryShimmer.scss";

function StockBasicDataSummaryShimmer() {
  return (
    <LandingTypography className="landing-typography_dark">
      <div className="flex justify-between align-start gap-4 mb-2">
        <Shimmer className="stock-basic-data-summary-shimmer__ticker" />
        <div className="flex flex-col align-end gap-1">
          <Shimmer className="stock-basic-data-summary-shimmer__market" />
          <Shimmer className="stock-basic-data-summary-shimmer__change" />
          <Shimmer className="stock-basic-data-summary-shimmer__price" />
        </div>
      </div>
      <Shimmer className="stock-basic-data-summary-shimmer__quote-date" />
    </LandingTypography>
  );
}

export default StockBasicDataSummaryShimmer;
